(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-benefits"] && !Shopify.designMode) return;
  try {
    class ProductBenefits extends HTMLElement {
    connectedCallback() {
      this.distributeItems();
    }

    distributeItems() {
      const source = this.querySelector('.product-benefits__items-source');
      const leftColumn = this.querySelector('[data-column="left"]');
      const rightColumn = this.querySelector('[data-column="right"]');

      if (!source || !leftColumn || !rightColumn) return;

      const items = source.querySelectorAll('.benefit-item');

      items.forEach((item) => {
        const column = item.dataset.column;
        if (column === 'left') {
          leftColumn.appendChild(item.cloneNode(true));
        } else if (column === 'right') {
          rightColumn.appendChild(item.cloneNode(true));
        }
      });

      // Remove the source container after distribution
      source.remove();
    }
  }

  if (!customElements.get('product-benefits')) {
    customElements.define('product-benefits', ProductBenefits);
  }
  } catch(e) { console.error(e); }
})();

})();
